/* FIGS accent: when a colour is picked on a FIGS product/set page, tint the top
   announcement bar (and the Add to Bag button is tinted by the section itself) to
   that colour for a lively, on-brand feel. One shared <style> tag repaints the bar
   with !important so it works regardless of the theme's internal bar structure. */
(function () {
  function hexToRgb(hex) {
    var c = (hex || '').trim().replace('#', '');
    if (c.length === 3) c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2];
    if (c.length < 6) return null;
    var r = parseInt(c.substr(0, 2), 16), g = parseInt(c.substr(2, 2), 16), b = parseInt(c.substr(4, 2), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return null;
    return { r: r, g: g, b: b };
  }
  function isLight(c) { return (0.299 * c.r + 0.587 * c.g + 0.114 * c.b) > 150; }
  function styleEl() {
    var el = document.getElementById('figs-accent-style');
    if (!el) { el = document.createElement('style'); el.id = 'figs-accent-style'; document.head.appendChild(el); }
    return el;
  }
  window.figsAccent = {
    textFor: function (hex) { var c = hexToRgb(hex); if (!c) return '#fff'; return isLight(c) ? '#111' : '#fff'; },
    tint: function (hex) {
      var c = hexToRgb(hex); if (!c) return;
      var trip = c.r + ' ' + c.g + ' ' + c.b;
      var light = isLight(c);
      var tHex = light ? '#111' : '#fff';
      var tTrip = light ? '17 17 17' : '255 255 255';
      styleEl().textContent =
        'announcement-bar.announcement-bar{background:' + hex + ' !important;background-image:none !important;' +
        '--bg-color:' + trip + ';--bg-gradient:' + hex + ';--text-color:' + tTrip + ';--heading-color:' + tTrip + ';--link-color:' + tTrip + ';}' +
        'announcement-bar .announcement-bg{background:' + hex + ' !important;background-image:none !important;}' +
        'announcement-bar .announcement,announcement-bar .announcement *,announcement-bar .announcement__text,' +
        'announcement-bar .announcement a,announcement-bar .announcement-button{color:' + tHex + ' !important;}' +
        /* Judge.me review widget follows the chosen product colour */
        '.jdgm-star{color:' + hex + ' !important;}' +
        '.jdgm-write-rev-link,.jdgm-btn.jdgm-btn--solid,.jdgm-submit-rev{background:' + hex + ' !important;border-color:' + hex + ' !important;color:' + tHex + ' !important;}' +
        '.jdgm-rev__buyer-badge,.jdgm-verified-badge,.jdgm-rev__buyer-badge-wrapper .jdgm-rev__buyer-badge{background:' + hex + ' !important;color:' + tHex + ' !important;}' +
        '.jdgm-histogram__bar-content{background:' + hex + ' !important;}' +
        '.jdgm-rev__author,.jdgm-all-reviews-text__text{color:' + hex + ' !important;}';
    },
    reset: function () { var el = document.getElementById('figs-accent-style'); if (el) el.textContent = ''; }
  };
})();
